export default __webpack_public_path__ + "feb4129.png";